import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useProductTypes } from '../../hooks/useProductTypeSearchParams';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// the order of these dictates the order they appear!
export const SORT_OPTIONS = {
  RELEVANCE: ['APP', 'AGENT', 'SOLUTIONS_PARTNER_PROFILE', 'WORKFLOW_TEMPLATE'],
  PROFILE_SOLUTIONS_PARTNER_TIER: ['SOLUTIONS_PARTNER_PROFILE'],
  MOST_INSTALLED: ['APP', 'AGENT'],
  MOST_POPULAR: ['WORKFLOW_TEMPLATE'],
  NEWEST: ['APP', 'AGENT', 'SOLUTIONS_PARTNER_PROFILE', 'WORKFLOW_TEMPLATE'],
  NAME_AZ: ['APP', 'AGENT', 'SOLUTIONS_PARTNER_PROFILE'],
  NAME_ZA: ['APP', 'AGENT', 'SOLUTIONS_PARTNER_PROFILE'],
  ALPHABETICAL: ['WORKFLOW_TEMPLATE']
};
export function SortDropdown() {
  const params = useSearchParams();
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const productTypes = useProductTypes();

  // a sort option is valid if its supported product types fully includes the current product types
  const validSortOptions = Object.keys(SORT_OPTIONS).filter(o => productTypes.every(p => SORT_OPTIONS[o].includes(p)));
  const selectedSortOption = params.get('sort', {
    allowedValues: validSortOptions
  });
  const handleSortChange = sort => {
    params.set('sort', sort, {
      defaultValue: 'RELEVANCE'
    });
    const searchTerm = params.get('search') || undefined;
    trackMarketplaceEvent(getMarketplaceInteractionEvent(Object.assign({
      action: 'sort changed',
      sorts: [sort],
      type: productTypes
    }, searchTerm && {
      search: searchTerm
    })));
  };
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexShrink: 0,
    marginInlineStart: "auto",
    children: [/*#__PURE__*/_jsx(View, {
      flexShrink: 0,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.searchResults.sort.label"
      })
    }), /*#__PURE__*/_jsx(Dropdown, {
      buttonUse: "transparent",
      buttonText: localizeSortOption(selectedSortOption),
      children: /*#__PURE__*/_jsx(List, {
        children: validSortOptions.map(option => /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(Button, {
            onClick: () => handleSortChange(option),
            children: localizeSortOption(option)
          })
        }, option))
      })
    })]
  });
}
function localizeSortOption(sortOption) {
  switch (sortOption) {
    case 'MOST_INSTALLED':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.searchResults.sort.options.mostInstalled"
      });
    case 'MOST_POPULAR':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.searchResults.sort.options.mostPopular"
      });
    case 'NEWEST':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.searchResults.sort.options.newest"
      });
    case 'NAME_AZ':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.searchResults.sort.options.nameAZ"
      });
    case 'NAME_ZA':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.searchResults.sort.options.nameZA"
      });
    case 'ALPHABETICAL':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.searchResults.sort.options.alphabetical"
      });
    case 'PROFILE_SOLUTIONS_PARTNER_TIER':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.searchResults.sort.options.partnerTier"
      });
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.searchResults.sort.options.relevance"
      });
  }
}